import { render, staticRenderFns } from "./CouponRecord.vue?vue&type=template&id=36fc5f74&scoped=true&"
import script from "./CouponRecord.vue?vue&type=script&lang=js&"
export * from "./CouponRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc5f74",
  null
  
)

export default component.exports